import { useAuth } from "../../context/AuthContext";

interface PrivateElementProps {
  children: any;
  permissions: any[];
}

export const PrivateElement = ({
  children,
  permissions,
}: PrivateElementProps) => {
  const { user } = useAuth();

  return (
    <>{permissions?.some((x) => user.rights.includes(x)) && <>{children}</>}</>
  );
};
